<template>
  <div class="notifications">
    <Notification
      v-if="notification"
      :notification="notification"
      @close="notification = null"
    />
  </div>
</template>

<script lang="ts">
import { debounce } from "lodash-es";
import { defineComponent, onUnmounted, PropType, ref } from "vue";

import type { Notification as INotification } from "@ctrl/controller-rpc";
import { Hook } from "@ctrl/hook";

import Notification from "./Notification.vue";

export default defineComponent({
  components: {
    Notification,
  },
  props: {
    hook: { type: Object as PropType<Hook<INotification>>, required: true },
  },
  setup(props) {
    const hook = props.hook;
    const notification = ref<INotification | null>(null);
    const close = debounce(() => (notification.value = null), 6000);
    const subscription = hook.attach((notif: INotification) => {
      // We could decouple the formatting of a notification from its semantics,
      // which would allow the following filtering to be cleaner.
      notification.value = notif;
      if (notif.type === "error" || notif.type === "warning") close.cancel();
      else close();
    });
    onUnmounted(() => hook.detach(subscription));
    return { notification };
  },
});
</script>
